import React from 'react';

const Consejo = () => {
  const [consejo, setConsejo] = React.useState([]);
  let topPosition = 0;
  React.useEffect(() => {
    getConsejo();
  }, []);

  const getConsejo = async () => {
    let url = '/api/adminLogin?action=postVotes';
    let consejoList = await fetch(url, { method: 'POST' });
    let consejoListDef = await consejoList.json()
    setConsejo(consejoListDef);
  };
  return (
    <div className='heroes'>
      <h1>Consejo</h1>
      <table id="consejo">
        <tr className="trtitulo">
          <td>#</td>
          <td>Nombre de Consejero</td>
          <td>Votos</td>
          <td>Extras</td>
          <td>Nerfeos</td>
          <td>Total</td>
        </tr>
        {consejo
        .sort((a, b) => ((b.vote + b.extra * 2) - b.nerf) - ((a.vote + a.extra * 2) - a.nerf))
        .map(consejo => (
          <tr key="item._id">
            <td>{topPosition += 1}</td>
            <td>
              <div><span>{consejo.displayname}</span></div>
            </td>
            <td>{consejo.vote}</td>
            <td>{consejo.extra}</td>
            <td>{consejo.nerf}</td>
            <td>{(consejo.vote + (consejo.extra * 2)) - consejo.nerf}</td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default Consejo;